import { UpdateKeyValueRequest } from "@models/base/updateKeyValueRequest.model";

export class UpdateAudienciaRequest  extends UpdateKeyValueRequest{

  public sala!: string | null;
  public lugar!: string | null;
  public fecha!: string;
  public idTipoAudiencia!: number;
  public idEstadoAudiencia!: number;
  public idExpediente!: number;
  public asignadoA: number | null = null;
  public notificado: boolean | null = null;
  public linkVirtual: string | null = null;
  public resultadoAudiencia: string | null = null;
  public requiereActa: boolean | null = null;
  public actaGenerada: boolean | null = null;
  public actaUrl: string | null = null;
}
